import { PatientFullDetailsType } from "PatientCare/PatientBooking/v2/types";
import React, { createContext, useState } from "react";
import Encounterform from "./Encounterform";


export type EncounterContextType = {
  encounter: number;
  insuranceId: number;
  searchflag: boolean;

  setEncounter: React.Dispatch<React.SetStateAction<number>>;
  setInusranceId: React.Dispatch<React.SetStateAction<number>>;
  setSearchflag: React.Dispatch<React.SetStateAction<boolean>>;
  encounterDetails: any;

  setEncounterDetails: (details: PatientFullDetailsType | null) => void;
};
const EncounterContext = createContext<EncounterContextType | undefined>(
  undefined
);
export default function PatientEncounterv2() {
  const [encounter, setEncounter] = useState(0);
  const [insuranceId, setInusranceId] = useState(0);
  const [searchflag, setSearchflag] = useState(false);
  const [encounterDetails, setEncounterDetails] = useState<PatientFullDetailsType | null>(null);
  return (
    <EncounterContext.Provider
      value={{
        encounter,
        setEncounter,
        insuranceId,
        setInusranceId,
        encounterDetails,
        setEncounterDetails,
        searchflag,
        setSearchflag,
      }}
    >
      <Encounterform/>
    </EncounterContext.Provider>
  );
}

export { EncounterContext };
